import { Fragment } from 'react'

import { SEARCH_SNIPPET_HIGHLIGHT_MARK_CLASS } from 'src/constants/searchHighlight'

/** Renders OpenSearch highlight snippets that wrap matches in `<em>` tags. */
export const parseOpenSearchEmSnippet = (snippet: string): React.ReactNode[] => {
  const parts = snippet.split(/(<\/?em>)/gi)
  const nodes: React.ReactNode[] = []
  let inEm = false

  parts.forEach((part, idx) => {
    const normalized = part.toLowerCase()
    if (normalized === '<em>') {
      inEm = true
      return
    }
    if (normalized === '</em>') {
      inEm = false
      return
    }
    if (!part) {
      return
    }
    nodes.push(
      inEm ? (
        <mark key={idx} className={SEARCH_SNIPPET_HIGHLIGHT_MARK_CLASS}>
          {part}
        </mark>
      ) : (
        <Fragment key={idx}>{part}</Fragment>
      )
    )
  })

  return nodes
}
